import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AppBar,
  Toolbar,
  Tabs,
  Tab,
} from "@mui/material";
import { ExpandMore, QuestionAnswer } from "@mui/icons-material";
import colors from "../constants/colors";

const FAQs = () => {
  return (
    <Box sx={{ height: "100vh",
        display: "flex",
        flexDirection: "column",}}>
      {/* Header with Tabs */}
      <AppBar
        position="sticky"
        sx={{
          bgcolor: "white",
          color: colors.darkBlack,
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <Toolbar
          sx={{
            justifyContent: "space-between",
            gap: 2,
            alignItems: "center",
            minHeight: "64px !important",
            px: { xs: 2, sm: 3 },
          }}
        >
          {/* Single Tab for FAQs */}
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              overflow: "hidden",
              mr: 2,
            }}
          >
            <Tabs
              value={0}
              sx={{
                minHeight: "48px",
                "& .MuiTabs-indicator": {
                  backgroundColor: colors.green,
                  height: 3,
                  borderRadius: 3,
                },
                "& .MuiTab-root": {
                  fontWeight: 600,
                  textTransform: "none",
                  fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
                  minWidth: "auto",
                  px: { xs: 1, sm: 3 },
                  minHeight: "48px",
                  whiteSpace: "nowrap",
                },
                "& .MuiTab-root.Mui-selected": {
                  color: colors.green,
                },
              }}
            >
              <Tab
                icon={
                  <QuestionAnswer
                    sx={{ mr: 1, fontSize: { xs: "18px", sm: "20px" } }}
                  />
                }
                iconPosition="start"
                label="Frequently Asked Questions"
              />
            </Tabs>
          </Box>

     
        </Toolbar>
      </AppBar>

      {/* Content */}
      <Box sx={{ p: 3, maxWidth: 1200, margin: '0 auto' }}>
        {/* Introduction Card */}
        <Card sx={{ mb: 4, borderRadius: 3, backgroundColor: colors.lightMint, border: `2px solid ${colors.green}` }}>
          <CardContent sx={{ textAlign: 'center' }}>
            <Typography variant="h5" sx={{ mb: 2, color: colors.darkGreen }}>
              Welcome to OK Market!
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.6 }}>
              OK Market is your complete online Krushi (agriculture) marketplace where farmers can buy, sell, 
              and manage their farming business efficiently. Connect with buyers, track your finances, and grow 
              your farming enterprise with our comprehensive platform.
            </Typography>
          </CardContent>
        </Card>

        {/* FAQ Accordions */}
        <Box sx={{ mb: 4 }}>
          <Accordion sx={{ mb: 2, borderRadius: '12px !important', overflow: 'hidden' }}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6" sx={{ fontWeight: 600, color: colors.darkGreen }}>
                1. What is OK Market?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" sx={{ mb: 2 }}>
                OK Market is an online Krushi marketplace designed specifically for farmers and agricultural businesses. 
                It's a comprehensive platform where you can:
              </Typography>
              <Typography variant="body2" component="div" sx={{ pl: 2 }}>
                • Buy and sell animals, tools, and crops<br/>
                • Manage your farming finances with income-expense tracking<br/>
                • Connect with other farmers in discussion forums<br/>
                • Get detailed reports about your farming business<br/>
                • Access special membership plans for unlimited posting
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ mb: 2, borderRadius: '12px !important', overflow: 'hidden' }}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6" sx={{ fontWeight: 600, color: colors.darkGreen }}>
                2. What are the membership plans available?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" sx={{ mb: 2, fontWeight: 600, color: colors.darkGreen }}>
                We offer two main membership plans:
              </Typography>
              
              <Card sx={{ mb: 2, backgroundColor: '#f0f8f0', border: `1px solid ${colors.green}` }}>
                <CardContent>
                  <Typography variant="h6" sx={{ color: colors.darkGreen }}>
                    🎯 Purchase Plan - ₹99 for 1 Year
                  </Typography>
                  <Typography variant="body2">
                    • Unlimited product posts (animals, tools, crops)<br/>
                    • Direct access to buyers and sellers<br/>
                    • Full platform features access<br/>
                    • Priority customer support
                  </Typography>
                </CardContent>
              </Card>

              <Card sx={{ backgroundColor: '#fff8f0', border: `1px solid ${colors.orange}` }}>
                <CardContent>
                  <Typography variant="h6" sx={{ color: colors.orange }}>
                    🤝 Referral Plan - FREE Unlimited Access
                  </Typography>
                  <Typography variant="body2">
                    • Refer 10 users to activate this plan<br/>
                    • Reach 100 points (10 successful referrals) for unlimited posts<br/>
                    • Earn unlimited selling posts for 1 year upon activation<br/>
                    • Perfect for building your farming network
                  </Typography>
                </CardContent>
              </Card>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ mb: 2, borderRadius: '12px !important', overflow: 'hidden' }}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6" sx={{ fontWeight: 600, color: colors.darkGreen }}>
                3. How does the referral system work?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Our referral system helps you grow while helping others join our farming community:
              </Typography>
              <Typography variant="body2" component="div" sx={{ pl: 2 }}>
                • Each successful referral gives you 10 points<br/>
                • Suppose you have 3 referrals, you will get 30 points so you can make 3 posts<br/>
                • When you reach 100 points (10 referrals), you get UNLIMITED posts for 1 year<br/>
                • Your referred users must join and be active on the app<br/>
                • Track your referral progress in the app dashboard
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ mb: 2, borderRadius: '12px !important', overflow: 'hidden' }}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6" sx={{ fontWeight: 600, color: colors.darkGreen }}>
                4. What is "Charcha" section?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Charcha is our community discussion forum where you can:
              </Typography>
              <Typography variant="body2" component="div" sx={{ pl: 2 }}>
                • Ask questions to admin and other farmers<br/>
                • Discuss farming techniques and best practices<br/>
                • Clarify doubts about points and referral system<br/>
                • Share experiences and learn from others<br/>
                • Get expert advice on agricultural matters
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ mb: 2, borderRadius: '12px !important', overflow: 'hidden' }}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6" sx={{ fontWeight: 600, color: colors.darkGreen }}>
                5. How does income-expense tracking work?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" sx={{ mb: 2 }}>
                Our financial tracking feature helps you manage your farming business efficiently:
              </Typography>
              <Typography variant="body2" component="div" sx={{ pl: 2 }}>
                • Add daily income from sales of animals, crops, and products<br/>
                • Track expenses like animal feed, equipment, and maintenance<br/>
                • Generate monthly and yearly financial reports<br/>
                • Analyze profit/loss for your farming activities<br/>
                • Make informed decisions based on financial data<br/>
                • Export reports for accounting purposes
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ mb: 2, borderRadius: '12px !important', overflow: 'hidden' }}>
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="h6" sx={{ fontWeight: 600, color: colors.darkGreen }}>
                6. How can I benefit from OK Market?
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1" sx={{ mb: 2 }}>
                OK Market helps you transform your farming business:
              </Typography>
              <Typography variant="body2" component="div" sx={{ pl: 2 }}>
                • <strong>Expand Your Market:</strong> Reach buyers across regions<br/>
                • <strong>Financial Management:</strong> Track and optimize your earnings<br/>
                • <strong>Community Support:</strong> Learn from fellow farmers<br/>
                • <strong>Cost-Effective:</strong> Affordable plans with great value<br/>
                • <strong>Time-Saving:</strong> Manage everything in one app<br/>
                • <strong>Growth Opportunities:</strong> Scale your business with our platform
              </Typography>
              <Typography variant="body1" sx={{ mt: 2, fontStyle: 'italic', color: colors.darkGreen }}>
                "Join thousands of farmers who are already managing their farming efficiently with OK Market!"
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Box>
    </Box>
  );
};

export default FAQs;